import PolicyPageLayout from "../components/PolicyPageLayout";

const sections = [
  {
    title: "Demo-first guidance",
    body: [
      "QA Coder encourages learners to attend a free demo or speak with the team before joining a paid course.",
      "This helps you choose the right program based on your goal, experience level, and schedule.",
    ],
  },
  {
    title: "Refund handling",
    body: [
      "Refund eligibility depends on course access, batch start status, attended sessions, and any materials already shared.",
      "Refund requests should be raised directly with QA Coder support with payment details and the reason for cancellation.",
    ],
  },
  {
    title: "Batch transfer",
    body: [
      "Where possible, QA Coder may support batch transfer or schedule adjustment instead of cancellation.",
      "Final approval depends on mentor availability and batch capacity.",
    ],
  },
];

export default function RefundPolicy() {
  return (
    <PolicyPageLayout
      eyebrow="Refunds"
      title="Refund Policy"
      description="Refund and batch-transfer guidance for QA Coder course learners."
      sections={sections}
    />
  );
}
